export default __webpack_public_path__ + "static/media/03.10c3c15f.jpg";